module.exports = __webpack_public_path__ + "static/tr-cityvan-7dc25058dc765d2ff5d9374eaf3738fe.png";